export default {
    'SETTINGS.EMAIL.BUILDER.PAGE_TITLE': 'Emails',
    'SETTINGS.EMAIL.BUILDER.FILTER.ALL': 'All',
    'SETTINGS.EMAIL.BUILDER.FILTER.CONFIRMATION': 'Confirmation',
    'SETTINGS.EMAIL.BUILDER.FILTER.UPDATE': 'Update',
    'SETTINGS.EMAIL.BUILDER.FILTER.CANCELLATION': 'Cancellation',
    'SETTINGS.EMAIL.BUILDER.FILTER.REMINDER': 'Reminder',
    'SETTINGS.EMAIL.BUILDER.COLUMN.SUB_ACCOUNT': 'Sub account',
    'SETTINGS.EMAIL.BUILDER.COLUMN.METHOD': 'Method',
    'SETTINGS.EMAIL.BUILDER.COLUMN.EMAIL_TYPE': 'Email type',
    'SETTINGS.EMAIL.BUILDER.COLUMN.STATUS': 'Status',
    'SETTINGS.EMAIL.BUILDER.COLUMN.LAST_UPDATE': 'Last update',
    'SETTINGS.EMAIL.BUILDER.STATUS.DEFAULT': 'Default',
    'SETTINGS.EMAIL.BUILDER.STATUS.CUSTOMISED': 'Customised',
    'SETTINGS.EMAIL.BUILDER.PERMISSION_LABEL': 'Email configuration',
    'SETTINGS.EMAIL.BUILDER.BACK_TO_EMAILS': 'Back to emails',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.TITLE': 'Configuration',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.SUB_ACCOUNT': 'Sub account',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.METHOD': 'Method',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.EMAIL_TYPE': 'Email type',
    'SETTINGS.EMAIL.BUILDER.SUBJECT.TITLE': 'Subject',
    'SETTINGS.EMAIL.BUILDER.HEADER.TITLE': 'Header content',
    'SETTINGS.EMAIL.BUILDER.HEADER.DESCRIPTION': 'The greeting and introduction of your email',
    'SETTINGS.EMAIL.BUILDER.BODY.TITLE': 'Body content',
    'SETTINGS.EMAIL.BUILDER.BODY.DESCRIPTION': 'Details of the appointment. Type freely, add variables with the "Insert variable" button',
    'SETTINGS.EMAIL.BUILDER.INSERT_VARIABLE': 'Insert variable',
    'SETTINGS.EMAIL.BUILDER.INSERT_LINK': 'Insert link',
    'SETTINGS.EMAIL.BUILDER.LINK.TEXT_TO_DISPLAY': 'Text to display',
    'SETTINGS.EMAIL.BUILDER.LINK.ERRORS.INVALID_DOMAIN': 'Please enter a valid domain',
    'SETTINGS.EMAIL.BUILDER.LINK.ACTIONS.INSERT': 'Insert',
    // eslint-disable-next-line max-len
    'SETTINGS.EMAIL.BUILDER.CONDITIONAL_VARIABLES_WARNING': 'Variables in orange are conditional, available only for certain methods (e.g. appointment_address only for In branch).',
    'SETTINGS.EMAIL.BUILDER.APPOINTMENT_TYPE_DESCRIPTION.TITLE': 'Appointment type description',
    'SETTINGS.EMAIL.BUILDER.APPOINTMENT_TYPE_DESCRIPTION.HINT': 'Turn on to include the appointment description in the email',
    'SETTINGS.EMAIL.BUILDER.ADDITIONAL_TEXT.TITLE': 'Additional text',
    'SETTINGS.EMAIL.BUILDER.ADDITIONAL_TEXT.DESCRIPTION': 'Free text for any extra information you want to share with your clients',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.TITLE': 'Action buttons',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.DESCRIPTION': 'For appointment booked via SC, include cancel or reschedule links',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.CANCEL': 'Cancel my appointment',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.MODIFY': 'Modify my appointment',
    'SETTINGS.EMAIL.BUILDER.FOOTER.TITLE': 'Footer content',
    'SETTINGS.EMAIL.BUILDER.FOOTER.DESCRIPTION': 'Closing phrase of your email',
    'SETTINGS.EMAIL.BUILDER.PREVIEW.TITLE': 'Preview',
    'SETTINGS.EMAIL.BUILDER.PREVIEW.SUBTITLE': 'Variables replaced with sample values',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.SAVE': 'Save',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.SEND_TEST': 'Send a test',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.RESET': 'Reset to default',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.RESET_CONFIRM': 'Reset',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.RESET_CANCEL': 'Cancel',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.STAY_ON_PAGE': 'Stay on page',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.LEAVE_WITHOUT_SAVING': 'Leave without saving',
    'SETTINGS.EMAIL.BUILDER.ERRORS.REQUIRED_FIELD': 'This field is required',
    'SETTINGS.EMAIL.BUILDER.ERRORS.MAX_LENGTH': 'Maximum {n} characters',
    'SETTINGS.EMAIL.BUILDER.ALERTS.UNSAVED_CHANGES_TITLE': 'Unsaved changes',
    'SETTINGS.EMAIL.BUILDER.ALERTS.UNSAVED_CHANGES': 'Any unsaved changes will be lost. Do you want to exit?',
    'SETTINGS.EMAIL.BUILDER.ALERTS.RESET_TITLE': 'Reset this email to its default content?',
    // eslint-disable-next-line max-len
    'SETTINGS.EMAIL.BUILDER.ALERTS.RESET_DESCRIPTION': 'Your customizations (header, body, footer, additional text, buttons) will be lost unless you cancel.',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SAVE_SUCCESS': 'Changes saved',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SEND_TEST_SUCCESS': 'Test email sent',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SEND_TEST_SUCCESS_COUNT': 'Test sent to {n} address | Test sent to {n} addresses',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SAVE_BEFORE_SEND_TEST': 'Please save your changes before sending a test',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.RESET_SUCCESS': 'Template reset to its default content',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.TITLE': 'Send a test email',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.RECIPIENTS': 'Recipients',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.PLACEHOLDER': 'Add an email...',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.HINT_EMPTY': 'Add up to 5 recipients',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.RECIPIENTS_LEFT': '{n} recipient left | {n} recipients left',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.INVALID_EMAIL': 'Invalid email address',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.CANCEL': 'Cancel',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.SEND': 'Send test',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.SENDING': 'Sending...',
};
